import { 
  SELECT_SHADOW, 
  SET_SHADOW_DIRTY,
} from '../actions/index';

export default function(state = { isDirty: false }, action) {
  switch (action.type) {
  case SELECT_SHADOW:
    return { 
      ...state,
      selectedShadow: action.shadow,
    };
  case SET_SHADOW_DIRTY:
    return {
      ...state,
      isDirty: action.isDirty,
    };
  default:
    return state;
  }
}
